export const landingLocales = {
  ar: {
    lang: 'ar',
    dir: 'rtl',
    fontFamily: "'Tajawal', 'Cairo', system-ui, sans-serif",
    switchTo: 'EN',
    brand: {
      name: 'وفاء للولاء',
      mark: 'Wafaa Loyalty',
      short: 'وفاء',
    },
    nav: {
      features: 'المميزات',
      cardTypes: 'البطاقات',
      industries: 'من يستفيد؟',
      how: 'كيف يعمل',
      pricing: 'الأسعار',
      testimonials: 'آراء العملاء',
      contact: 'تواصل معنا',
      login: 'تسجيل الدخول',
      subscriberLogin: 'دخول المشتركين',
      dashboard: 'لوحة التحكم',
      cta: 'ابدأ مجاناً',
      menu: 'القائمة',
    },
    hero: {
      badge: 'منصة الولاء الأولى في الخليج',
      titlePrefix: 'حوّل عملاءك العابرين إلى',
      titleHighlight: 'عملاء دائمين',
      subtitle:
        'برنامج ولاء احترافي جاهز في 5 دقائق — بدون تقنية، بدون تعقيد. اجعل عملاءك يعودون مراراً وتكراراً.',
      primaryCta: 'ابدأ تجربتك المجانية',
      secondaryCta: 'شاهد كيف يعمل',
      trust: '+500 متجر يثق بوفاء للولاء',
      floatingTop: '+٢٤ عميل جديد اليوم',
      floatingBottom: 'محمد حصل على مكافأة!',
    },
    wallet: {
      title: 'بطاقة رقمية جاهزة للمحفظة',
      addGoogle: 'إضافة إلى محفظة Google',
      addApple: 'إضافة إلى Apple Wallet',
      hint: 'روابط حفظ متوافقة مع Google Wallet و Apple Wallet عند تفعيل الشهادات.',
    },
    mockup: {
      metrics: [
        ['١٢٤', 'عميل نشط'],
        ['٨٩٪', 'معدل العودة'],
        ['٤٥', 'مكافأة هذا الشهر'],
        ['٣.٢×', 'متوسط الزيارات'],
      ],
      chartTitle: 'نمو العملاء هذا الشهر',
      store: 'كافيه النخيل',
      card: 'بطاقة أختام القهوة',
    },
    stats: [
      ['+٥٠٠', 'متجر نشط'],
      ['٩٨٪', 'رضا العملاء'],
      ['+٥٠٬٠٠٠', 'عميل مسجّل'],
      ['١٤ يوم', 'تجربة مجانية'],
    ],
    featuresSection: {
      label: 'المميزات',
      title: 'بطاقات رقمية وأدوات نمو في منصة واحدة',
      subtitle:
        'أطلق تجربة ولاء سهلة لعملائك، وتابع عودتهم ومكافآتهم وحملاتك التسويقية من لوحة تحكم واحدة.',
      items: [
        {
          icon: '🃏',
          title: 'بطاقات ولاء رقمية أبل وجوجل ووليت',
          desc: 'امنح عملاءك بطاقات أختام ونقاط وكاش باك تحمل هوية منشأتك، ويحفظونها بسهولة في Apple Wallet وGoogle Wallet دون تنزيل تطبيق جديد.',
        },
        {
          icon: '🤖',
          title: 'ذكاء اصطناعي تحليلي',
          desc: 'محرك AI يحلل سلوك عملائك ويقترح توصيات فورية لزيادة المبيعات والاحتفاظ بالعملاء.',
        },
        {
          icon: '📱',
          title: 'QR Code فوري',
          desc: 'ضع QR Code على كاشيرك — العميل يمسحه ويُسجَّل تلقائياً. سريع، سهل، بدون تعقيد.',
        },
        {
          icon: '📊',
          title: 'تقارير مفصّلة',
          desc: 'رسوم بيانية واضحة لنمو عملائك، معدلات العودة، والمكافآت المستبدلة — كل شيء في لمحة.',
        },
        {
          icon: '👥',
          title: 'إدارة العملاء',
          desc: 'قاعدة بيانات كاملة لعملائك مع تحليل خطر المغادرة وتصنيف تلقائي حسب مستوى النشاط.',
        },
        {
          icon: '📢',
          title: 'حملات تسويقية',
          desc: 'أرسل حملات مستهدفة للعملاء الغائبين أو القريبين من المكافأة — بمساعدة الذكاء الاصطناعي.',
        },
      ],
    },
    cardTypes: {
      label: 'البطاقات',
      title: 'برنامج ولاء للمقاهي والمطاعم والمتاجر ينمو معك',
      subtitle:
        'اختر طريقة المكافأة التي تناسب سلوك عملائك وهدفك التجاري؛ من زيادة تكرار الزيارة إلى رفع متوسط الفاتورة وبناء علاقة تدوم.',
      items: [
        {
          badge: 'متاح الآن',
          icon: '🃏',
          title: 'بطاقة الأختام',
          desc: 'العميل يجمع ختماً في كل زيارة أو شراء، وعند اكتمال العدد يحصل على مكافأة مجانية أو خصم. الأنسب للمقاهي والمغاسل والخدمات السريعة.',
          example: 'مثال: اشترِ ٩ قهوات واحصل على العاشرة مجاناً ☕',
          background: 'linear-gradient(135deg,#EDE5FF,#D4C3FF)',
        },
        {
          badge: 'متاح الآن',
          icon: '⭐',
          title: 'نظام نقاط للعملاء',
          desc: 'حوّل كل عملية شراء إلى نقاط واضحة يستبدلها العميل بمكافآت أو خصومات، وشجّعه على رفع قيمة مشترياته والعودة إلى منشأتك بوتيرة أكبر.',
          example: 'مثال: كل ١٠ ريال = ١ نقطة، و١٠٠ نقطة = خصم ١٠ ريال 💰',
          background: 'linear-gradient(135deg,#FEF3C7,#FDE68A)',
        },
        {
          badge: 'متاح الآن',
          icon: '💵',
          title: 'بطاقة الكاش باك',
          desc: 'نسبة من كل فاتورة تعود كرصيد للعميل يستخدمه لاحقاً. خيار قوي لرفع متوسط السلة وتحفيز الشراء المتكرر.',
          example: 'مثال: استرجع ٥٪ من كل فاتورة كرصيد للزيارة القادمة 🎁',
          background: 'linear-gradient(135deg,#D1FAE5,#A7F3D0)',
        },
        {
          badge: 'متاح الآن',
          icon: '📋',
          title: 'بطاقة الاشتراك',
          desc: 'قدّم باقات بعدد زيارات أو مدة زمنية محددة للوجبات الصحية واللياقة والغسيل والخدمات المتكررة بطريقة منظمة وسهلة.',
          example: 'مثال: ١٢ زيارة خلال ٣٠ يوماً بسعر ثابت وواضح',
          background: 'linear-gradient(135deg,#DBEAFE,#BFDBFE)',
        },
        {
          badge: 'قريباً',
          icon: '🎟️',
          title: 'بطاقة الخصم',
          desc: 'امنح خصماً بنسبة أو مبلغ ثابت مع صلاحية وعدد استخدامات وحد أقصى للتحميل لتشغيل عروض سريعة وذكية.',
          example: 'مثال: خصم ١٥٪ لأول ١٠٠ عميل خلال أسبوع',
          background: 'linear-gradient(135deg,#FCE7F3,#FBCFE8)',
        },
        {
          badge: 'قريباً',
          icon: '🤝',
          title: 'بطاقة الإحالة',
          desc: 'حوّل عملاءك الحاليين إلى قناة نمو عبر مكافآت للطرفين عند إحالة صديق جديد. مناسبة لخفض تكلفة اكتساب العميل.',
          example: 'مثال: أحِل صديقاً واحصل أنت وهو على ٢٠ ريال رصيد',
          background: 'linear-gradient(135deg,#FED7AA,#FDBA74)',
        },
      ],
    },
    industries: {
      label: 'من يستفيد؟',
      title: 'برامج ولاء السحابة للمتاجر في السعودية والخليج',
      subtitle: 'من المقهى المستقل إلى سلسلة الفروع، تمنحك وفاء نظاماً سحابياً مرناً يعمل من أي مكان ويتكيّف مع رحلة العميل في نشاطك.',
      items: [
        ['☕', 'الكافيهات والمقاهي', 'اجعل كل فنجان قهوة خطوة نحو مكافأة تُعيد العميل مجدداً'],
        ['🚗', 'مغاسل السيارات', 'حوّل كل غسيل إلى ختم في بطاقة الولاء وكافئ العميل المنتظم'],
        ['🍽️', 'المطاعم والمطابخ', 'برامج نقاط وأختام تُشجّع التكرار وتزيد متوسط الفاتورة'],
        ['💇', 'صالونات التجميل', 'عملاء الصالون يعودون أكثر حين يعرفون أن مكافأة تنتظرهم'],
        ['🏋️', 'الصالات الرياضية', 'كافئ الانتظام بنقاط وعروض خاصة تُحفّز الاستمرار'],
        ['🛒', 'البقالات والسوبرماركت', 'نظام كاش باك يُحوّل كل عملية شراء إلى رصيد للزيارة القادمة'],
        ['💊', 'الصيدليات', 'برنامج نقاط يبني ولاء الزبون ويزيد التكرار في صيدليتك'],
        ['🧴', 'متاجر العناية والتجميل', 'بطاقات ولاء أنيقة تعكس هوية علامتك وتُعزّز ارتباط العميل بها'],
      ],
    },
    how: {
      label: 'كيف يعمل',
      title: 'ابدأ في 3 خطوات بسيطة',
      subtitle: 'من التسجيل لأول ختم في أقل من 5 دقائق',
      steps: [
        ['🃏', 'أنشئ بطاقتك', 'اختر نوع البطاقة وخصّص التصميم والمكافأة من لوحة التحكم البسيطة'],
        ['📱', 'شارك الـ QR', 'ضع QR Code على كاشيرك أو شاركه على واتساب — العميل يمسح ويسجّل فوراً'],
        ['📈', 'تابع نمو عملائك', 'راقب الإحصائيات واستخدم توصيات الذكاء الاصطناعي لزيادة عودة العملاء'],
      ],
    },
    pricing: {
      label: 'الأسعار',
      title: 'اختر الباقة المناسبة لمتجرك',
      subtitle: 'جرّب مجاناً ١٤ يوماً — بدون بطاقة ائتمان',
      monthly: 'شهري',
      annual: 'سنوي',
      save: 'وفّر 10% 🎉',
      month: 'ريال/شهر',
      annualMonth: 'ريال/شهر عند الدفع السنوي',
      annualNote: (price, total) => `يعادل ${price} ريال/شهر ويُفوتر سنوياً ${total} ريال`,
      trialCta: 'ابدأ مجاناً',
      popular: 'الأكثر طلباً ⭐',
      plans: [
        {
          name: 'باقة انطلاق',
          desc: 'بداية قوية للمتاجر الصغيرة التي تريد إطلاق الولاء بسرعة وبتكلفة منخفضة.',
          price: 69,
          note: 'فرع واحد وموظفان مع سعة مناسبة للبداية',
          items: ['فرع واحد', 'موظفان اثنان', '٦٠٠ عميل', 'بطاقتا ولاء', '٤ حملات تسويقية', 'تقارير وتحليلات', 'ذكاء اصطناعي مساعد', 'إدارة موظفين'],
        },
        {
          name: 'باقة نمو',
          desc: 'الخيار الموصى به للمتاجر التي تنمو وتحتاج فروعاً وموظفين وحملات أكثر.',
          price: 119,
          note: 'أفضل توازن بين السعر وسعة التشغيل اليومية',
          featured: true,
          items: ['٣ فروع', '٦ موظفين', '٤ بطاقات ولاء', '٣٠٠٠ عميل', '٩ حملات تسويقية', 'تقارير وتحليلات', 'ذكاء اصطناعي مساعد', 'إدارة موظفين'],
        },
        {
          name: 'باقة ريادة',
          desc: 'للعلامات متعددة الفروع التي تحتاج سعة عالية وتشغيلاً بلا حدود يومية.',
          price: 99.5,
          originalPrice: 199,
          annualBasePrice: 199,
          launchOffer: 'خصم 50% لأول 100 مشترك بمناسبة الإطلاق، والخصم مدى الحياة على الفوترة الشهرية.',
          note: 'سعة عالية مع حدود مفتوحة للفرق والعملاء والحملات',
          items: ['٩ فروع', 'موظفون لا محدود', 'بطاقات ولاء لا محدودة', 'عملاء لا محدود', 'حملات تسويقية لا محدودة', 'تقارير وتحليلات', 'ذكاء اصطناعي مساعد', 'إدارة موظفين'],
        },
      ],
    },
    testimonials: {
      label: 'آراء العملاء',
      title: 'ماذا يقول أصحاب المتاجر؟',
      subtitle: 'أكثر من ٥٠٠ متجر يثق بوفاء للولاء في السعودية والخليج',
      items: [
        ['أ', 'أحمد المطيري', 'صاحب كافيه — الرياض', 'زادت عودة عملائي بنسبة ٦٠٪ خلال شهرين فقط. المنصة سهلة جداً والذكاء الاصطناعي يعطيني توصيات مفيدة كل يوم.'],
        ['س', 'سارة العتيبي', 'صاحبة صالون — جدة', 'بسيطة ومحترفة. نصبتها في ٥ دقائق وبدأت أول أختام نفس اليوم. عملائي معجبون جداً بالبطاقة الرقمية.'],
        ['م', 'محمد الشمري', 'صاحب مطعم — الدمام', 'أفضل استثمار لمطعمي. المنصة تساعدني أعرف أي العملاء بحاجة لمتابعة وأرسل لهم عروض مناسبة تلقائياً.'],
      ],
    },
    cta: {
      title: 'جاهز لتحويل متجرك؟',
      subtitle: 'انضم لأكثر من ٥٠٠ متجر يستخدم وفاء للولاء اليوم',
      primary: 'ابدأ مجاناً اليوم ←',
      secondary: 'تواصل معنا',
    },
    footer: {
      desc: 'برنامج الولاء الذكي للمتاجر والمطاعم في السعودية والخليج. حوّل زوارك إلى عملاء مخلصين.',
      platform: 'المنصة',
      support: 'الدعم',
      legal: 'قانوني',
      links: {
        features: 'المميزات',
        how: 'كيف يعمل',
        pricing: 'الأسعار',
        register: 'إنشاء حساب',
        guide: 'دليل البدء',
        whatsapp: 'واتساب',
        email: 'البريد الإلكتروني',
        privacy: 'سياسة الخصوصية',
        terms: 'شروط الاستخدام',
        refund: 'سياسة الإرجاع',
      },
      copyright: '© ٢٠٢٥ وفاء للولاء — جميع الحقوق محفوظة',
      whatsappLabel: 'تواصل معنا عبر واتساب',
      whatsappShort: 'واتس',
    },
  },
  en: {
    lang: 'en',
    dir: 'ltr',
    fontFamily: "'Manrope', 'Segoe UI', system-ui, sans-serif",
    switchTo: 'AR',
    brand: {
      name: 'Wafaa Loyalty',
      mark: 'Wafaa Loyalty',
      short: 'Wafaa',
    },
    nav: {
      features: 'Features',
      cardTypes: 'Cards',
      industries: 'Who benefits?',
      how: 'How it works',
      pricing: 'Pricing',
      testimonials: 'Customer stories',
      contact: 'Contact us',
      login: 'Login',
      subscriberLogin: 'Subscriber login',
      dashboard: 'Dashboard',
      cta: 'Start free',
      menu: 'Menu',
    },
    hero: {
      badge: "The Gulf's leading loyalty platform",
      titlePrefix: 'Turn one-time customers into',
      titleHighlight: 'loyal regulars',
      subtitle:
        'A professional loyalty program ready in 5 minutes — no technical work, no complexity. Bring your customers back again and again.',
      primaryCta: 'Start your free trial',
      secondaryCta: 'See how it works',
      trust: 'Trusted by 500+ stores',
      floatingTop: '+24 new customers today',
      floatingBottom: 'Mohammed earned a reward!',
    },
    wallet: {
      title: 'Wallet-ready digital card',
      addGoogle: 'Add to Google Wallet',
      addApple: 'Add to Apple Wallet',
      hint: 'Save links are ready for Google Wallet and Apple Wallet once certificates are enabled.',
    },
    mockup: {
      metrics: [
        ['124', 'Active customers'],
        ['89%', 'Return rate'],
        ['45', 'Rewards this month'],
        ['3.2x', 'Average visits'],
      ],
      chartTitle: 'Customer growth this month',
      store: 'Palm Cafe',
      card: 'Coffee Stamp Card',
    },
    stats: [
      ['500+', 'Active stores'],
      ['98%', 'Customer satisfaction'],
      ['50,000+', 'Registered customers'],
      ['14 days', 'Free trial'],
    ],
    featuresSection: {
      label: 'Features',
      title: 'Everything you need in one platform',
      subtitle:
        'From digital loyalty cards to AI-powered analytics — every tool in one place',
      items: [
        {
          icon: '🃏',
          title: 'Digital loyalty cards',
          desc: 'Create beautiful stamp, points, and cashback cards in minutes. No app required, works directly on any phone.',
        },
        {
          icon: '🤖',
          title: 'AI analytics',
          desc: 'An AI engine analyzes customer behavior and suggests instant recommendations to increase sales and retention.',
        },
        {
          icon: '📱',
          title: 'Instant QR Code',
          desc: 'Place a QR Code at checkout — customers scan it and register automatically. Fast, simple, and frictionless.',
        },
        {
          icon: '📊',
          title: 'Detailed reports',
          desc: 'Clear charts for customer growth, return rates, and redeemed rewards — everything at a glance.',
        },
        {
          icon: '👥',
          title: 'Customer management',
          desc: 'A complete customer database with churn-risk analysis and automatic segmentation by activity level.',
        },
        {
          icon: '📢',
          title: 'Marketing campaigns',
          desc: 'Send targeted campaigns to absent customers or those close to a reward — powered by AI.',
        },
      ],
    },
    cardTypes: {
      label: 'Cards',
      title: 'Choose the loyalty model that fits your business',
      subtitle:
        'Flexible loyalty programs for cafes, restaurants, retailers, and service businesses, with live card types now and more coming soon.',
      items: [
        {
          badge: 'Available now',
          icon: '🃏',
          title: 'Stamp Card',
          desc: 'Customers collect a stamp on every visit or purchase, then earn a free reward or discount when the card is complete. Ideal for cafes, car washes, and quick services.',
          example: 'Example: Buy 9 coffees and get the 10th free ☕',
          background: 'linear-gradient(135deg,#EDE5FF,#D4C3FF)',
        },
        {
          badge: 'Available now',
          icon: '⭐',
          title: 'Points Card',
          desc: 'Customers earn points based on purchase value, then redeem them for rewards or discounts. Great for retailers, restaurants, and pharmacies.',
          example: 'Example: every SAR 10 = 1 point, and 100 points = SAR 10 off 💰',
          background: 'linear-gradient(135deg,#FEF3C7,#FDE68A)',
        },
        {
          badge: 'Available now',
          icon: '💵',
          title: 'Cashback Card',
          desc: 'A percentage of every bill returns as balance the customer can use later. A strong way to increase basket size and repeat purchases.',
          example: 'Example: get 5% of every bill back as credit for the next visit 🎁',
          background: 'linear-gradient(135deg,#D1FAE5,#A7F3D0)',
        },
        {
          badge: 'Available now',
          icon: '📋',
          title: 'Subscription Card',
          desc: 'Offer visit-based or time-based packages for healthy meals, fitness, laundry, and recurring services in a simple organized flow.',
          example: 'Example: 12 visits within 30 days for one clear fixed price',
          background: 'linear-gradient(135deg,#DBEAFE,#BFDBFE)',
        },
        {
          badge: 'Coming soon',
          icon: '🎟️',
          title: 'Discount Card',
          desc: 'Offer percentage or fixed-amount discounts with expiration, usage limits, and loading caps for fast smart promotions.',
          example: 'Example: 15% off for the first 100 customers this week',
          background: 'linear-gradient(135deg,#FCE7F3,#FBCFE8)',
        },
        {
          badge: 'Coming soon',
          icon: '🤝',
          title: 'Referral Card',
          desc: 'Turn existing customers into a growth channel with rewards for both sides when they refer a new friend.',
          example: 'Example: refer a friend and both of you get SAR 20 credit',
          background: 'linear-gradient(135deg,#FED7AA,#FDBA74)',
        },
      ],
    },
    industries: {
      label: 'Who benefits?',
      title: 'Wafaa Loyalty fits every business',
      subtitle: 'From a small cafe to a retail chain — our platform adapts perfectly to your business model',
      items: [
        ['☕', 'Cafes and coffee shops', 'Make every cup of coffee a step toward a reward that brings the customer back'],
        ['🚗', 'Car washes', 'Turn every wash into a stamp on the loyalty card and reward regular customers'],
        ['🍽️', 'Restaurants and kitchens', 'Points and stamp programs that encourage repeat visits and increase average order value'],
        ['💇', 'Beauty salons', 'Salon customers return more often when they know a reward is waiting'],
        ['🏋️', 'Gyms and fitness studios', 'Reward consistency with points and special offers that motivate members to continue'],
        ['🛒', 'Groceries and supermarkets', 'A cashback system that turns every purchase into credit for the next visit'],
        ['💊', 'Pharmacies', 'A points program that builds customer loyalty and increases repeat visits to your pharmacy'],
        ['🧴', 'Beauty and care stores', 'Elegant loyalty cards that reflect your brand and strengthen customer connection'],
      ],
    },
    how: {
      label: 'How it works',
      title: 'Start in 3 simple steps',
      subtitle: 'From signup to the first stamp in less than 5 minutes',
      steps: [
        ['🃏', 'Create your card', 'Choose the card type and customize the design and reward from the simple dashboard'],
        ['📱', 'Share the QR', 'Place the QR Code at checkout or share it on WhatsApp — the customer scans and joins instantly'],
        ['📈', 'Track customer growth', 'Monitor analytics and use AI recommendations to increase returning customers'],
      ],
    },
    pricing: {
      label: 'Pricing',
      title: 'Choose the right plan for your store',
      subtitle: 'Try it free for 14 days — no credit card required',
      monthly: 'Monthly',
      annual: 'Annual',
      save: 'Save 10% 🎉',
      month: 'SAR/month',
      annualMonth: 'SAR/month billed annually',
      annualNote: (price, total) => `Equivalent to SAR ${price}/month and billed annually at SAR ${total}`,
      trialCta: 'Start free',
      popular: 'Most popular ⭐',
      plans: [
        {
          name: 'Launch',
          desc: 'A strong start for small stores that want to launch loyalty quickly at a low cost.',
          price: 69,
          note: 'One branch and two staff accounts for a clean start',
          items: ['1 branch', '2 employees', '600 customers', '2 loyalty cards', '4 marketing campaigns', 'Reports and analytics', 'AI assistant', 'Employee management'],
        },
        {
          name: 'Growth',
          desc: 'Recommended for growing stores that need more branches, staff, loyalty cards, and campaigns.',
          price: 119,
          note: 'The best balance between price and daily operating capacity',
          featured: true,
          items: ['3 branches', '6 employees', '4 loyalty cards', '3,000 customers', '9 marketing campaigns', 'Reports and analytics', 'AI assistant', 'Employee management'],
        },
        {
          name: 'Leadership',
          desc: 'For multi-branch brands that need high capacity and open-ended daily operations.',
          price: 99.5,
          originalPrice: 199,
          annualBasePrice: 199,
          launchOffer: '50% off for the first 100 launch subscribers, lifetime discount on monthly billing.',
          note: 'High-capacity operations with open staff, customer, card, and campaign limits',
          items: ['9 branches', 'Unlimited employees', 'Unlimited loyalty cards', 'Unlimited customers', 'Unlimited marketing campaigns', 'Reports and analytics', 'AI assistant', 'Employee management'],
        },
      ],
    },
    testimonials: {
      label: 'Customer stories',
      title: 'What store owners say',
      subtitle: 'More than 500 stores trust Wafaa Loyalty across Saudi Arabia and the Gulf',
      items: [
        ['A', 'Ahmed Almutairi', 'Cafe owner — Riyadh', 'My customer return rate increased by 60% in just two months. The platform is very easy and the AI gives me useful recommendations every day.'],
        ['S', 'Sarah Alotaibi', 'Salon owner — Jeddah', 'Simple and professional. I set it up in 5 minutes and started collecting stamps the same day. My customers really like the digital card.'],
        ['M', 'Mohammed Alshammari', 'Restaurant owner — Dammam', 'The best investment for my restaurant. The platform helps me know which customers need follow-up and send them suitable offers automatically.'],
      ],
    },
    cta: {
      title: 'Ready to transform your store?',
      subtitle: 'Join more than 500 stores using Wafaa Loyalty today',
      primary: 'Start free today →',
      secondary: 'Contact us',
    },
    footer: {
      desc: 'A smart loyalty program for stores and restaurants in Saudi Arabia and the Gulf. Turn visitors into loyal customers.',
      platform: 'Platform',
      support: 'Support',
      legal: 'Legal',
      links: {
        features: 'Features',
        how: 'How it works',
        pricing: 'Pricing',
        register: 'Create account',
        guide: 'Getting started',
        whatsapp: 'WhatsApp',
        email: 'Email',
        privacy: 'Privacy policy',
        terms: 'Terms of use',
        refund: 'Refund policy',
      },
      copyright: '© 2025 Wafaa Loyalty — All rights reserved',
      whatsappLabel: 'Contact us on WhatsApp',
      whatsappShort: 'WA',
    },
  },
};

export const defaultLandingLocale = 'ar';
